"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
var base_1 = require("../../themes/base");
var mixins_1 = require("../../utils/mixins");
var LinkSection = styled_components_1.default.div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  margin-top: 8px;\n  ", ";\n  ", ";\n"], ["\n  margin-top: 8px;\n  ", ";\n  ", ";\n"])), mixins_1.addBreakpoint(base_1.base.global.breakpoints.xs, "padding: " + base_1.spacing().xsmall + " 0;", 'up'), mixins_1.addBreakpoint(base_1.base.global.breakpoints.sm, "padding: " + base_1.spacing(32).xlarge + " 0;", 'up'));
exports.default = LinkSection;
var templateObject_1;
//# sourceMappingURL=LinkSection.js.map